import { useEffect, useState } from "react";

export type UserRole = "super_admin" | "manager" | "dsm" | null;

export function useUserRole() {
  const [role, setRole] = useState<UserRole>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUserRole = async () => {
      try {
        const response = await fetch("/api/auth/me", {
          credentials: "include",
        });

        if (!response.ok) {
          setRole(null);
          setLoading(false);
          return;
        }

        const data = await response.json();

        console.log("AUTH ME RESPONSE:", data);

        // ✅ Extract role safely from ANY backend format
        const backendRole =
          data?.role ||
          data?.roles?.[0] ||
          data?.user?.role ||
          data?.user?.roles?.[0] ||
          null;

        let normalized: UserRole = null;

        if (backendRole) {
          const r = backendRole.toLowerCase();

          if (r.includes("super")) normalized = "super_admin";
          else if (r.includes("admin") || r.includes("manager"))
            normalized = "manager";
          else if (r.includes("dsm") || r.includes("sales"))
            normalized = "dsm";
        }

        setRole(normalized);

        if (normalized)
          localStorage.setItem("app_role", normalized);
        else
          localStorage.removeItem("app_role");

      } catch (err) {
        console.error("Role fetch error:", err);
        setRole(null);
      } finally {
        setLoading(false);
      }
    };

    fetchUserRole();
  }, []);

  return {
    role,
    loading,
    isAdmin: role === "manager" || role === "super_admin",
    isSuperAdmin: role === "super_admin",
  };
}